/**
 * Shared styles for Agentic Commerce dashboard pages.
 * These styles are designed to match the marketing site and may change
 * in the future to align with the current portal styles.
 * Provider-specific styles (aboutCard colors, logo) remain in each dashboard.
 */
export const agenticDashboardStyles = {
  root: {
    backgroundColor: '#e9edf1',
    minHeight: 'calc(100vh - 64px)',
    padding: '32px 35px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '8px',
  },
  pageTitle: {
    fontSize: '28px',
    fontWeight: 700,
    fontFamily: 'Poppins',
    color: '#012237',
  },
  pageSubtitle: {
    textAlign: 'left' as const,
    fontSize: '14px',
    fontFamily: 'Poppins',
    color: 'rgba(0, 0, 0, 0.7)',
    marginBottom: '24px',
    maxWidth: '100%',
  },
  contentContainer: {
    maxWidth: '100%',
    marginLeft: '0',
    marginRight: '0',
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    padding: '24px',
    marginBottom: '16px',
  },
  connectionCard: {
    display: 'flex',
    flexDirection: 'column' as const,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    padding: '24px',
  },
  resourcesCard: {
    display: 'flex',
    flexDirection: 'column' as const,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    padding: '24px',
    border: '1px solid #e0e0e0',
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: 600,
    fontFamily: 'Poppins',
    color: '#012237',
    marginBottom: '12px',
  },
  statusRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
  },
  statusLabel: {
    fontSize: '14px',
    fontFamily: 'Poppins',
    fontWeight: 500,
    color: '#012237',
    marginRight: '8px',
  },
  statusConnected: {
    fontSize: '14px',
    fontFamily: 'Poppins',
    fontWeight: 600,
    color: '#4caf50',
  },
  statusNotConnected: {
    fontSize: '14px',
    fontFamily: 'Poppins',
    fontWeight: 600,
    color: '#d32f2f',
  },
  description: {
    textAlign: 'left' as const,
    fontSize: '14px',
    fontFamily: 'Poppins',
    color: 'rgba(0, 0, 0, 0.7)',
    marginBottom: '16px',
    lineHeight: 1.6,
  },
  connectButton: {
    backgroundColor: '#4D57F8',
    color: '#ffffff',
    textTransform: 'none' as const,
    fontFamily: 'Poppins',
    fontWeight: 600,
    padding: '10px 24px',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: '#3D47E8',
    },
  },
  disconnectButton: {
    backgroundColor: '#d32f2f',
    color: '#ffffff',
    textTransform: 'none' as const,
    fontFamily: 'Poppins',
    fontWeight: 600,
    padding: '10px 24px',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: '#b71c1c',
    },
  },
  helperText: {
    fontSize: '13px',
    fontFamily: 'Poppins',
    color: 'rgba(0, 0, 0, 0.6)',
    marginTop: '12px',
  },
  resourcesList: {
    textAlign: 'left' as const,
    listStyle: 'disc' as const,
    paddingLeft: '20px',
    margin: 0,
  },
  resourceItem: {
    fontSize: '14px',
    fontFamily: 'Poppins',
    color: '#012237',
    marginBottom: '8px',
  },
  resourceLink: {
    color: '#012237',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  aboutCard: {
    display: 'flex',
    flexDirection: 'column' as const,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    backgroundColor: '#fff8f8',
    borderRadius: '8px',
    padding: '24px',
    border: '1px solid #ffcdd2',
  },
  dialogContent: {
    minWidth: '500px',
  },
  settingsCard: {
    display: 'flex',
    flexDirection: 'column' as const,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    padding: '24px',
    marginTop: '16px',
  },
};
